import styled from 'styled-components'
import { stoColor, stoMedia, stoRadius, stoShadow, stoSpace } from 'constants/stoTheme'

/** Figma segmented control: grey track, the active item a raised white tab. */
export const RangeTrack = styled.div`
  display: inline-flex;
  gap: ${stoSpace[1]};
  padding: ${stoSpace[1]};
  /* Never wider than its card; past that the tabs scroll instead of spilling out. */
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  background: ${stoColor.surfaceAlt};
  border-radius: ${stoRadius.lg};

  &::-webkit-scrollbar {
    display: none;
  }
`

export const RangeButton = styled.button<{ $active: boolean; $wide: boolean }>`
  flex: 0 0 auto;
  padding: ${stoSpace[1]} ${({ $wide }) => ($wide ? stoSpace[4] : stoSpace[2])};
  white-space: nowrap;
  /* The active tab outlined, as the trade venue tabs; the others keep the same box. */
  border: 1px solid ${({ $active }) => ($active ? stoColor.borderSubtle : 'transparent')};
  border-radius: ${stoRadius.sm};
  background: ${({ $active }) => ($active ? stoColor.surface : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? stoShadow.sm : 'none')};
  color: ${({ $active }) => ($active ? stoColor.textPrimary : stoColor.disabledText)};
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.6px;
  cursor: pointer;
  transition:
    background 150ms ease,
    color 150ms ease;

  &:hover {
    color: ${stoColor.textPrimary};
  }

  /* Four wide tabs fit a phone-width card at the compact padding. */
  ${stoMedia.belowDesktop} {
    padding-inline: ${({ $wide }) => ($wide ? stoSpace[3] : stoSpace[2])};
  }
`
